export const StoreKeys = {
  SETTINGS: "settings",
  LANG: "i18nextLng",
};

const Store = {
  SETTINGS: {
    async get() {
      return localStorage.getItem(StoreKeys.SETTINGS);
    },
    async set(settings: string) {
      return localStorage.setItem(StoreKeys.SETTINGS, settings);
    },
    async delete() {
      return localStorage.removeItem(StoreKeys.SETTINGS);
    },
  },
};

export { Store };
